module.exports = __webpack_public_path__ + "img/marketplace_web.4a4e5547.svg";